// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-07cd5114] {\n  margin-bottom: 0;\n}\n.title[data-v-07cd5114] {\n  font-family: \"UniSans-Bold-Italic\";\n  font-size: 52px;\n  text-align: center;\n}\n.sub-title[data-v-07cd5114] {\n  font-size: 36px;\n  font-weight: bold;\n}\n.banner[data-v-07cd5114] {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #eee;\n  padding: 10px 30px;\n  margin: 20px;\n}", ""]);
// Exports
module.exports = exports;
